import RequirementsDialog from 'lib/designSystem/RequirementsDialog';
import EnhancedTable from 'lib/designSystem/Table';
import React, { useState } from 'react';

const documentsTableHeaders = [
  { key: 'folio', label: 'Folio' },
  { key: 'subType', label: 'Código Doc.' },
  { key: 'businessName', label: 'Proveedor' },
  { key: 'businessIdentifier', label: 'Rut Proveedor' },
  { key: 'issuedDateShortString', label: 'Fecha Emisión' },
  { key: 'paymentDateShortString', label: 'Fecha Pago' },
  { key: 'daysToCount', label: 'Días' },
  { key: 'amount', label: 'Monto', type: 'money' },
];

const DocumentsModule = ({ selectedRequest }: { selectedRequest: any }) => {
  const [selectedDocumentId, setSelectedDocumentId] = useState<string>('');
  const [documentAlias, setDocumentAlias] = useState<string>('');
  const [openRequirementsDialog, setOpenRequirementsDialog] =
    useState<boolean>(false);

  const handleOpenRequirementsDialog = (rowId: string) => {
    const document = selectedRequest.documents.find(
      (document: any) => document.id === rowId,
    );
    if (document) {
      setSelectedDocumentId(document.id);
      setDocumentAlias(`Folio ${document.folio}`);
      setOpenRequirementsDialog(true);
    }
  };

  return (
    <div>
      <EnhancedTable
        dataHeaders={[
          {
            key: 'requirements',
            label: '',
            handleAction: handleOpenRequirementsDialog,
            type: 'requirements',
          },
          ...documentsTableHeaders,
        ]}
        data={selectedRequest.documents}
        rowsPerPageDefault={5}
        finalSumRow
        exportToFile="xlsx"
        exportHeaders={documentsTableHeaders}
      />
      {openRequirementsDialog && (
        <RequirementsDialog
          open={openRequirementsDialog}
          onClose={() => setOpenRequirementsDialog(false)}
          category={'confirmingDocument'}
          entityKey={'documentId'}
          entityId={selectedDocumentId}
          entityAlias={documentAlias}
        />
      )}
    </div>
  );
};

export default DocumentsModule;
